module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/4/3-bebc846fe239fd574debc27bf49dea4c.jpg";